import { render, staticRenderFns } from "./student-information.vue?vue&type=template&id=db04a086&scoped=true&"
import script from "./student-information.vue?vue&type=script&lang=js&"
export * from "./student-information.vue?vue&type=script&lang=js&"
import style0 from "./student-information.vue?vue&type=style&index=0&id=db04a086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04a086",
  null
  
)

component.options.__file = "student-information.vue"
export default component.exports